<template>
  <div>
    <b-field style="flex-wrap: wrap; margin-bottom:0px; margin-top:16px;">
      <p
        style="margin-right:1em; margin-left:24px; font-size: 13px; text-align:left; margin-bottom:0px;"
      >
        Introduce los 9 dígitos de tu número de colegiado
      </p>
    </b-field>

    <b-field
      id="colegiado-number"
      custom-class="is-small has-text-success"
      :type="colegiadoType"
      :message="colegiadoMsg"
      is-expanded
    >
      <b-icon class="onlyline-icon" pack="mdi" icon="barcode" size="is-small">
      </b-icon>
      <b-input
        type="text"
        class="onlyline professional_number"
        placeholder="XX  YY  ZZZZZ"
        v-mask="'99  99  99999'"
        v-model="professional_number"
        @blur="validateNumber"
        v-debounce:300ms="validateNumber"
        required
        ref="professional_numberField"
        :disabled="verificado"
      >
      </b-input>

      <a @click="showInfoModal = true">
        <b-icon pack="mdi" icon="information-outline" size="is-small"> </b-icon>
      </a>
    </b-field>
  </div>
</template>

<script>
/**
 * Gestiona la introducción del número de colegiado y su comprobación.
 * Emite eventos true/false cuando el número se ha comprobado
 * Requiere del nombre y apellido puesto que la comprobación con el colegio de médicos es
 */
import AwesomeMask from 'awesome-mask'

export default {
  props: {
    user_name: {
      type: String,
      required: true
    },
    user_surname: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      colegiadoType: '',
      colegiadoMsg: '',
      professional_number: '',
      verificado: false,
      showNoverificado: false
    }
  },
  computed: {
    getColegiadoClasses() {
      return this.colegiadoClasses
    }
  },
  methods: {
    generateProfessional_number() {
      return this.professional_number.replace(/ /g, '')
    },

    validateNumber() {
      console.log('validate number')
      this.isWaitingValidation = true
      this.$store
        .dispatch('register/validateDoctorData', {
          user_name: this.user_name,
          user_surname: this.user_surname,
          professional_number: this.generateProfessional_number()
        })
        .then(response => {
          //this.$store.commit('register/nextStep')
          console.log(response)
          if (response.data[0] == true) {
            this.$emit('input', {
              number: this.professional_number,
              isValid: true
            })

            this.colegiadoType = 'is-primary'
            this.colegiadoMsg = 'Usuario verificado'
            this.verificado = true
            this.showErrorModal = false
            this.showNoverificado = false
          } else {
            this.$emit('input', {
              number: this.professional_number,
              isValid: false
            })
            this.colegiadoType = 'is-danger'
            this.colegiadoMsg =
              'Este número de colegiado no parece correcto o no se corresponde con el nombre'
            //this.$emit('validation', false)
          }
        })
        .catch(error => {
          console.log(error)
          this.$emit('input', {
            number: this.professional_number,
            isValid: false
          })
        })
        .finally(() => {
          this.isWaitingValidation = false
        })
    }
  },
  directives: {
    mask: AwesomeMask
  }
}
</script>

<style lang="less" scoped></style>
